import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import PaginationCom from '../../Component/pagination'
import useTableSorting from '../../Hooks/useTableSorting';
import { Button, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import Loading from '../../Component/Loading';
import { ToastContainer, toast } from 'react-toastify';
import AddIcon from '@mui/icons-material/Add';
import NoRecordFound from '../../Component/NoRecordFound';
import { dailogAllMessage } from '../../Constants/Constants';
import Dialogs from '../../Component/Dialog';
import { BUSINESS_CATEGORY_LIST, EDIT_BUSINESS_CATEGORY } from '../../Repository/BusinessCategoryRepo';
import { BiArchiveIn } from 'react-icons/bi';
import { ARCHIVE_GST, GST_LIST } from '../../Repository/GSTSlabRepo';
const List = () => {
    const [open, setOpen] = useState(false);
    const [DeletedData, setDeletedData] = useState({});
    const [controller, setController] = useState({ page: 1, rowsPerPage: 10, searchPage: null });
    const [paginationTotalCount, setPaginationTotalCount] = useState(0)
    const [Filter, setFilter] = useState({
        archive: true,
        disable_button: true,
    })
    const [loading, setLoading] = useState(false)
    const [GstSlabList, setGstSlabList] = useState([])
    const naviget = useNavigate()
    const headCells = [
        { id: "#", numeric: false, disablePadding: true, label: "#", isShorted: false },
        { id: "gst", numeric: true, disablePadding: false, label: "GST (%)", isShorted: true },
        { id: "action", numeric: false, disablePadding: false, showLeft: true, label: "Action", isShorted: false },
    ];
    const { EnhancedTableHead, order, orderBy, stableSort, getComparator, handleRequestSort } = useTableSorting(headCells)


    const getGstSlabList = async () => {
        setLoading(true)
        const { page, rowsPerPage } = controller;
        const { archive } = Filter;
        let payload = {
            page: page,
            count: rowsPerPage,
            activeStatus: archive,

        }
        try {
            let response = await GST_LIST(payload)
            setGstSlabList(response?.data)
            setPaginationTotalCount(response?.totalCount)
        } catch (error) {
            if (error.message !== "Not Found") toast.error(error.message)
            setPaginationTotalCount(0)
            setGstSlabList([])
        }
        finally {
            setLoading(false)
        }
    }

    const handleClose = async (event, data) => {
        if (event === "YES") {
            setLoading(true)
            let payload = {
                gstId: data?.gstId,
                activeStatus: !data?.activeStatus
            }
            try {
                let response = await ARCHIVE_GST(payload)
                toast.success(response.message)
                setLoading(false)
                setOpen(false)
                if (GstSlabList?.length === 1) {
                    setController((pre) => ({ ...pre, page: controller.page > 1 ? controller.page - 1 : 1 }))
                } else getGstSlabList()
            } catch (error) {
                toast.error(error.message)
                setOpen(false)
                setLoading(false)
            }

        } else {
            setOpen(!open)
        }
    }

    useEffect(() => {
        getGstSlabList()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [controller])
    const handleChangeFilter = (event) => {
        const { name, value } = event.target
        setFilter((pre) => ({ ...pre, disable_button: false, [name]: value }))
    }
    const reset = () => {
        setController((pre) => ({ ...pre, page: pre.searchPage ?? pre.page, searchPage: null }))
        setFilter({
            archive: true,
            disable_button: true
        })
    }
    const HandleSearchList = () => {
        setController((pre) => ({ ...pre, searchPage: pre?.page, page: 1 }))
    }
    return (
        <>
            {loading && <Loading />}
            <ToastContainer />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 px-0">
                        <h3 className='PAGE-NAME'>GST Slab</h3>
                    </div>
                </div>
                <section className='d-flex justify-content-between row'>
                    <div className='col-10  col-xxl-10 col-xl-9 col-lg-8   px-0 col-12'>

                        <div className="row">
                            <div className="col-lg-4 col-sm-6">
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    className='w-100'
                                    size='small'
                                    name='archive'
                                    value={Filter?.archive}
                                    onChange={handleChangeFilter}
                                >
                                    <MenuItem value={true}>Unarchive</MenuItem>
                                    <MenuItem value={false}>Archive</MenuItem>
                                </Select>
                            </div>
                            <div className="mt-3 mt-lg-0 col-lg-4 d-flex justify-content-lg-start  justify-content-end ">
                                <Button variant="contained" disabled={Filter?.disable_button} className='me-2 mui_button_color' onClick={HandleSearchList}>search</Button>
                                <Button variant="contained" disabled={Filter?.disable_button} className='mui_button_color' onClick={reset}>reset</Button>
                            </div>
                        </div>
                    </div>

                    <div className='col-xxl-2 col-xl-3 col-lg-4 col-12 d-flex justify-content-end pe-0 mt-3 mt-lg-0'>
                        <Button variant="contained" className='mui_button_color' startIcon={<AddIcon />} onClick={() => naviget("add")}>
                            Add  GST Slab
                        </Button>
                    </div>

                </section>

                <div className="row">
                    {
                        GstSlabList?.length === 0 && <div className="col-sm-12 mt-3 text-center " >
                            <NoRecordFound />
                        </div>
                    }
                </div>
                <TableContainer className=" mt-4"  >
                    <Table
                        id="table_mui"
                        aria-labelledby="tableTitle"
                        size={"medium"}
                        aria-label="enhanced table"
                    >
                        {
                            <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} rowCount={GstSlabList.length} />
                        }
                        <TableBody>
                            {stableSort(GstSlabList, getComparator(order, orderBy)).map(
                                (row, index) => {
                                    const labelId = `enhanced-table-checkbox-${index}`;
                                    return <React.Fragment key={row?.businessCategoryId}>
                                        <TableRow id="hover_tr">
                                            <TableCell className="ps-3" component="th" id={labelId} scope="row" padding="none" >
                                                {controller?.rowsPerPage * (controller?.page - 1) + index + 1}
                                            </TableCell>
                                            <TableCell id={labelId} align="left" >{row?.rate}%</TableCell>
                                            <TableCell id={labelId} align="right" >
                                                <svg onClick={() => naviget(`/layout/gst-slab/edit?gstId=${row?.gstId}&gstRate=${row?.rate}`)} style={{ cursor: "pointer" }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-pencil-fill" viewBox="0 0 16 16">
                                                    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                                </svg>
                                                <BiArchiveIn title={`${row?.archive === false ? "Archive" : "Unarchive"}`} className="all_react_icons_color ms-2 " onClick={() => { setDeletedData(row); setOpen(!open) }} />
                                            </TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                }
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <section className='w-100 d-flex justify-content-end'>
                    {
                        paginationTotalCount > 10 && <PaginationCom count={paginationTotalCount} controller={controller} setController={setController} />
                    }
                </section>

            </div>
            <Dialogs handleClose={handleClose} title={!DeletedData?.activeStatus ? dailogAllMessage?.gstSlab?.UnArchive : dailogAllMessage?.gstSlab?.Archive} open={open} data={DeletedData} />
        </>
    )
}

export default List
